let set_cookie = (actionData) => {
    if (typeof window.Cookies === 'undefined') {
        console.error('window.Cookies is undefined / js-cookie is not installed');
        return;
    }
    let options = actionData?.options || {};
    window.Cookies.set(actionData.name, actionData.value, {
        sameSite: 'lax',
        expires: 365,
        ...options,
    })
};

export default set_cookie;
